import type { ShiftRecord } from '../types/records'
import { cn, inputClass } from '../lib/ui'

type Props = {
  shiftId: string
  shifts: ShiftRecord[]
  canAllShifts: boolean
  onChange: (shiftId: string) => void
  disabled?: boolean
  locked?: boolean
  className?: string
}

export function ShiftFilterSelect({
  shiftId,
  shifts,
  canAllShifts,
  onChange,
  disabled,
  locked,
  className,
}: Props) {
  return (
    <label className={cn('flex items-center gap-2 text-sm', className)}>
      <span className="font-medium text-su-text">Смена</span>
      <select
        className={cn(inputClass, 'min-w-40')}
        value={shiftId}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled || locked}
      >
        {canAllShifts && <option value="">Все смены</option>}
        {shifts.map((s) => (
          <option key={s.id} value={s.id}>
            {s.name}
          </option>
        ))}
      </select>
    </label>
  )
}
